<template>
  <span
    class="flex items-center gap-2 text-sm"
    :class="invalid ? 'c-grey-30' : ''"
    data-test-id="vf-form-validation"
  >
    <vf-icon
      :class="invalid ? 'c-grey-50 ' : 'c-green-30'"
      :name="invalid ? 'clear' : 'success'"
      size="md"
    />
    <slot />
  </span>
</template>

<script lang="ts" setup>
const { invalid = true } = defineProps<{ invalid?: boolean | string }>()
</script>
